import React, { useState } from 'react';
import './App.css';

function App() {
  const [city, setCity] = useState('');
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState('');

  const apiKey = 'a29c533c88553209f4a3977241a5815c'; // 🔁 Replace with your actual Weatherstack API key

  const getWeather = async () => {
    if (!city) return;

    const url = `http://api.weatherstack.com/current?access_key=${apiKey}&query=${city}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.success === false) {
        setError(data.error.info);
        setWeatherData(null);
      } else {
        setWeatherData(data);
        setError('');
      }
    } catch (err) {
      setError('Something went wrong!');
      setWeatherData(null);
    }
  };

  return (
    <div className="App">
      <h1>🌤️ SkyCast</h1>
      <div className="search">
        <input
          type="text"
          placeholder="Enter city name"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button onClick={getWeather}>Search</button>
      </div>

      {error && <p className="error">❌ {error}</p>}

      {weatherData && (
        <div className="weather-card">
          <h2>{weatherData.location.name}, {weatherData.location.country}</h2>
          <p><strong>{weatherData.current.weather_descriptions[0]}</strong></p>
          <p>🌡️ Temp: {weatherData.current.temperature}°C</p>
          <p>💧 Humidity: {weatherData.current.humidity}%</p>
          <p>💨 Wind: {weatherData.current.wind_speed} km/h</p>
          <p>🕒 Local Time: {weatherData.location.localtime}</p>
        </div>
      )}
    </div>
  );
}

export default App;
